import axios from "axios";

export const getRaCheckInCheckOut = async (params: {
    id: string,
    outin: string,
    recoveryMode?: boolean
}): Promise<any> => {
    const queryParams = new URLSearchParams();
    queryParams.append('isCheckOutIn', '0');

    if (params.recoveryMode !== undefined) {
        queryParams.append('recoveryMode', params.recoveryMode.toString());
    }

    const response = await axios.get(`/network/ra/${params.id}/checkoutin/${params.outin}?${queryParams.toString()}`);
    return response.data;
};
